import React, { useState } from 'react'
import FullQuestionView from './FullQuestionView';
import d10 from './FullQuestionView.module.css';

function QuestionModal({open,classNames,styles,animationDuration=300,closeFullView,questionData,onClose}) {
    const [isExiting, setIsExiting] = useState(false);

    const overlayAnimation = !isExiting
      ?  'overlayAnimationIn':'overlayAnimationOut'

    const modalAnimation = !isExiting
      ? 'modalAnimationIn':'modalAnimationOut'





      const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
          onClose();
         setIsExiting(false);
        }, animationDuration); // animation duration
      }



    return (open && questionData) ?

      <div className={d10.modalBackground}  style={{
          animation: `${overlayAnimation} ${animationDuration}ms`,
        }} >
        <div className={d10.modal}  style={{
          animation: `${modalAnimation} ${animationDuration}ms`,
          ...styles?.modal,
        }}>


<FullQuestionView
          closeFullView={handleClose}
          questionData={questionData}


        />


        </div>
      </div>

    

:null
}

export default QuestionModal